import { Link, useNavigate } from "react-router-dom";
import cssIf from "../../../../scripts/helpers/class.add.if";
import "./navigation.scss";
import useGlobal from "../../../../store";
import { useEffect, useMemo } from "react";

const Navigation = () => {

  const [ globalState, globalActions ] = useGlobal();
  const { dummy, user_role } = globalState;
  const { sign, updateRender } = globalActions;

  const navigate = useNavigate();

  const isActive = ( url ) => {

    const { href, origin } = window.location;
    return href.replace(origin, '') === url;

  }

  useEffect(() => { 
      
    async function checkRole() {

      const data = await sign.CheckRole();
      console.log('checkRole navigation data', data);

    }

    checkRole();

  }, []);
  
  const MENU = useMemo(() => {

    return [
              // {
              //   title: "Администраторы",
              //   items: [
              //     { text: "Все", url: "/admins?role=all" },
              //     { text: "Супер-админы", url: "/admins?role=super_admin" },
              //     { text: "Модераторы", url: "/admins?role=content_manager" },
              //   ],
              // },
              {
                title: "Статистика",
                items: [
                  { text: "Регистрации и оплаты", url: "/statistics/users" },
                  { text: "Платящие пользователи", url: "/statistics/buys-for-users" },
                ],
              },
            ];

  }, [ user_role ]);

  useEffect(() => {

    const currentPath = window.location.pathname;
    const isOnNewsPage = currentPath.startsWith('/news');

    if ( user_role === 'content_manager' && !isOnNewsPage ) { navigate('/news'); }

  }, [ user_role ]);

  return (

    <nav className = "menu">

      <div className = "logo">

        <Link to = "/"> DB Admin</Link>

      </div> 

      { MENU.map(( section, sectionIndex ) => (

        <div 
        
          key = { sectionIndex } 
          className = "menu__section"
          
        > 

          <div className = "menu__title">

            { section.title }
            
          </div>

          { section.items.map(( item, key ) => (

            <NavElement

              key = { key }
              url = { item.url }
              text = { item.text }
              isActive = { isActive( item.url ) }
            
            />

          ))}

        </div>

      ))}

    </nav>

  );

}

const NavElement = ({ text, url, isActive = false }) => (

  <Link

    to = { url }
    className = {`menu__link ${ cssIf( isActive, "menu__link--active" ) }`}

  >

    { text }

  </Link>

);

export default Navigation;